import * as ko from 'knockout';

import { BaseForm } from './base_form';
import { countriesApi, CountryData } from '../api/countries';
import { Deferred } from '../utils/deferred';
import { createWithComponent } from '../utils/ko_utils';
import { Country } from '../models/country';
import { applyCodeFormatValidation } from '../ko_bindings/slug_validation';
import { canChooseUnitGroup } from '../permissions';
import { session } from '../session';
import { makeUnitGroupFieldProps } from '../utils/unit_group_field';

let template = require('raw-loader!../../templates/country_edit.html').default;

class CountryEditScreen extends BaseForm<CountryData> {
  showRegions = session.isS2bim();
  country = ko.observable<Country>(null);
  showUnitGroup = canChooseUnitGroup();
  unitGroupFieldProps = ko.pureComputed(() =>
    makeUnitGroupFieldProps(this.country().unitGroup, { disabled: !this.country().canEdit() })
  );

  constructor(
    params: { id: string; initialName: string; result?: Deferred<CountryData> },
    componentInfo: KnockoutComponentTypes.ComponentInfo
  ) {
    super(params);

    let request = params.id ? countriesApi.retrieve(params.id) : undefined;
    let promise = Promise.all([request]).then(([data]) => {
      this.country(new Country(data));
      applyCodeFormatValidation(this.country().isoCountryCode);
      if (!data && params.initialName) {
        this.country().name(params.initialName);
      }
    });
    this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
  }

  save = () => {
    if (!this.country()) {
      return;
    }

    if (this.validateLocal(this.country)) {
      let data = this.country().toData();
      this.executeSaveRequest(countriesApi.save(data)).then((validation) => {
        this.onRemoteValidation(data, this.country(), validation);
      });
    }
  };

  dispose = () => {
    if (this.country()) {
      this.country().dispose();
    }
  };
}

export let countryEdit = {
  name: 'country-edit',
  viewModel: createWithComponent(CountryEditScreen),
  template: template,
};

ko.components.register(countryEdit.name, countryEdit);
